import { get, compact } from 'lodash-es';
import { getCabType } from 'site-modules/shared/utils/get-cab-type';
import { getEngineTypeValue } from 'site-modules/shared/utils/inventory/get-engine-type-value';

export function getVehicleLabel({ vehicleInfo, specialIdentifier = '', fallback = {} }) {
  const vehicleMake = get(vehicleInfo, 'styleInfo.make', '') || fallback.make;
  const vehicleModel = get(vehicleInfo, 'styleInfo.model', '') || fallback.model;
  const vehicleYear = get(vehicleInfo, 'styleInfo.year', '') || fallback.year;
  const vehicleTrim = get(vehicleInfo, 'styleInfo.trim', '') || fallback.trim;
  const vehicleCabType = getCabType(get(vehicleInfo, 'styleInfo', {}));
  const engineTypeValue = getEngineTypeValue({
    model: vehicleModel || '',
    trim: vehicleTrim || '',
    engineType: get(vehicleInfo, 'partsInfo.engineType'),
  });

  return compact([
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleTrim,
    engineTypeValue,
    vehicleCabType,
    specialIdentifier,
  ])
    .join(' ')
    .trim();
}
